

<ng-container *ngIf="!isLoading">
    <header>
        <img src="assets/images/inspection-types/{{parentNode.type.toLowerCase()}}.svg"
             class="logo"/>
        <chapps-header [label]="parentNode.label"></chapps-header>
        <h4 class="subtitle" >({{ 'templateChecklistNodeType_' + parentNode.type | translate }})</h4>
        <div>
        <ng-container *ngIf="!predefined; else predefinedButton">
            <div id="actions-dropdown-container" class="btn-group dropdowns" mdbDropdown>
                <i mdbDropdownToggle class="fa fa-lg fa-ellipsis-v clickable ml-3 px-1" placement="bottom">
                </i>
                <div class="dropdown-menu dropdown-primary dropdown-menu-right">
                    <a *ngIf="parentNode.businessId" class="dropdown-item" [translate]="Localization.RenameChecklist" (click)="renameChecklist()"></a>
                    <a class="dropdown-item" [translate]="Localization.EditChecklistType" (click)="changeChecklistType()"></a>
                    <a class="dropdown-item" [translate]="Localization.DeleteChecklist" (click)="deleteChecklist()"></a>
                    <a class="dropdown-item" [translate]="Localization.CopyChecklistBuilding" (click)="onCopyChecklist()"></a>
                </div>
            </div>
        </ng-container>
        <ng-template #predefinedButton>
            <chapps-primary-button [label]="Localization.EditChecklist" [outline]="true" [small]="true" [icon]="'fa-edit'" (clicked)="editPredefinedChecklist()"></chapps-primary-button>
        </ng-template>
        </div>
    </header>

    <main>
            <header class="checklist-header">
                <i class="fa"
                   [class.fa-caret-right]="!allNodesExpanded"
                   [class.fa-caret-down]="allNodesExpanded"
                   (click)="expandAll()"></i>
                <span>{{ Localization.Label | translate }}</span>
                <span>{{ Localization.Evaluation | translate }}</span>
                <span>
                    <ng-container *ngIf="!predefined">
                        {{ Localization.Mandatory | translate }}
                    </ng-container>
                </span>
                <div class="btn-group dropdowns"
                     mdbDropdown
                     *ngIf="!predefined">
                    <i mdbDropdownToggle class="fas fa-plus more clickable" id="checkpoint-dropdown-container"></i>
                    <div class="dropdown-menu dropdown-primary dropdown-menu-right">
                        <a class="dropdown-item"
                           [translate]="Localization.AddSection"
                           (click)="addNewGroup($event)"></a>
                        <a class="dropdown-item"
                           [translate]="Localization.AddCheckpoint"
                           (click)="addNewCheckpoint($event)"></a>
                    </div>
                </div>
            </header>
            <app-checklist-node [node]="parentNode"
                                [buildingId]="buildingId"
                                [allDroplists]="checkpointDroplistIds"
                                [readOnly]="predefined"
                                (onBecameStale)="loadDetails()"></app-checklist-node>

    </main>
</ng-container>